import { get, post } from "../../helpers/api_helper"

// fetch AccReceivable
export const fetchTransactionHistory = data => {
  return get(`transaction-history/search?${data?.params}`)
}
